import {
  Component,
  EventEmitter,
  InjectionToken,
  Injector,
  Input,
  input,
  InputSignal,
  Output,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { RouterModule } from '@angular/router';
import { NzFormModule } from 'ng-zorro-antd/form';
import { CommonModule, DatePipe, NgTemplateOutlet } from '@angular/common';
import { ColumnType, ITableColumn, ITablePagination } from '../table/table.types';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NIASBizBllModelsAuthDocumentPreviewInfo } from '../../api/v1';

@Component({
  selector: 'app-expandable-table',
  templateUrl: './expandable-table.component.html',
  styleUrl: './expandable-table.scss',
  imports: [
    TranslatePipe,
        NzButtonModule,
    NzTableModule,
    NzEmptyModule,
    NzIconModule,
    RouterModule,
    NzFormModule,
    NgTemplateOutlet,
    DatePipe,
    CommonModule,
  ],
})
export class ExpandableTableComponent {
  public ColumnType = ColumnType;
  public allChecked = false;
  public fixedColumn = false;
  public dynamicComponent = input<any>();

  public tableColumns: InputSignal<ITableColumn<NIASBizBllModelsAuthDocumentPreviewInfo>[]> = input.required<ITableColumn<NIASBizBllModelsAuthDocumentPreviewInfo>[]>();
  public tableData: InputSignal<any[]> = input.required<any[]>();
  public tablePagination: InputSignal<ITablePagination> = input({
    total: 0,
    pageSize: 10,
    pageIndex: 1,
  });

  public queryParamsTable = output<NzTableQueryParams>();

  private expandedRows: Set<any> = new Set();
  @Output() rowExpanded = new EventEmitter<any>();
  @Output() tableRefresh = new EventEmitter<void>();

  constructor(private injector: Injector) {}

  refreshFromChild = () => {
    this.tableRefresh.emit();
  };
  toggleExpand(row: any): void {
    if (this.expandedRows.has(row)) {
      this.expandedRows.delete(row);
      this.rowExpanded.emit(null);
    } else {
      this.expandedRows.add(row);
      this.rowExpanded.emit(row);
    }
  }

  createInjector(row: any): Injector {
    return Injector.create({
      providers: [{ provide: 'ROW_DATA', useValue: row }],
      parent: this.injector,
    });
  }

  isRowExpanded(row: any): boolean {
    return this.expandedRows.has(row);
  }

  public onQueryParamsChange(event: NzTableQueryParams) {
    this.queryParamsTable.emit(event);
  }

  public checkAll(event: boolean) {
    //console.log(event);
  }

  public checkRowChange(data: any) {
    this.tableRefresh.emit();
  }
}
